/**
 * @file コンポーネント：フル動画ページスレッドポップアップ新規作成、編集ページ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { ModalThreadConfirm } from "~/src/components/pages/Video/Video/ModalThreadConfirm";
import { Button } from "~/src/components/uiparts/Button";
import { InputText } from "~/src/components/uiparts/InputText";
import { Paragraph } from "~/src/components/uiparts/Paragraph";
import { Textarea } from "~/src/components/uiparts/Textarea";

// スタイル読み込み
import {
    StyledButtonList,
    StyledButtonListItem,
    StyledContainer,
    StyledFormList,
    StyledFormListDetail,
    StyledFormListTerm,
    StyledFormListTermLabel,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledContainer>
            {/* 確認モーダル */}
            <ModalThreadConfirm
                fnOnClickAgree={() =>
                    props.setCurrentPage(
                        props.currentPage === "new" ? "list" : "detail"
                    )
                }
                isOpenModalThreadConfirm={props.isOpenModalThreadConfirm}
                paragraph={localized["Message.CancelEditThread"]}
                setIsOpenModalThreadConfirm={props.setIsOpenModalThreadConfirm}
            />
            <StyledFormList>
                {/* エラーメッセージ */}
                {props.errorMessageNewEdit && (
                    <Paragraph
                        onColor="white"
                        paragraphType="error"
                        text={props.errorMessageNewEdit}
                    />
                )}
                {/* タイトル */}
                <StyledFormListTerm className="is-required">
                    <StyledFormListTermLabel htmlFor="ThreadTitle">
                        {localized["Label.ThreadTitle"]}
                    </StyledFormListTermLabel>
                </StyledFormListTerm>
                <StyledFormListDetail onClick={() => props.fnMessageClear()}>
                    <InputText
                        id="ThreadTitle"
                        isWide={true}
                        name="ThreadTitle"
                        refInputText={props.refInputTitle}
                        type="text"
                    />
                </StyledFormListDetail>
                {/* 本文 */}
                <StyledFormListTerm className="is-required">
                    <StyledFormListTermLabel htmlFor="threadText">
                        {localized["Label.ThreadBody"]}
                    </StyledFormListTermLabel>
                </StyledFormListTerm>
                <StyledFormListDetail onClick={() => props.fnMessageClear()}>
                    <Textarea
                        id="threadText"
                        isWide={true}
                        name="threadText"
                        refTextarea={props.refTextareaText}
                    />
                </StyledFormListDetail>
            </StyledFormList>
            {/* ボタンリスト */}
            <StyledButtonList>
                {/* キャンセルボタン */}
                <StyledButtonListItem>
                    <Button
                        buttonType="cancel"
                        href="#"
                        icon={[
                            <i className="fas fa-ban" key="icon-cancel"></i>,
                        ]}
                        onClick={(e) => {
                            e.preventDefault();
                            props.setIsOpenModalThreadConfirm(true);
                            props.fnMessageClear();
                        }}
                        text={localized["Label.Cancel"]}
                    />
                </StyledButtonListItem>
                {/* 投稿、編集ボタン */}
                <StyledButtonListItem>
                    <Button
                        buttonType="submit"
                        href="#"
                        icon={[
                            props.currentPage === "new" ? (
                                <i className="fas fa-plus" key="icon-post"></i>
                            ) : (
                                <i className="fas fa-pen" key="icon-edit"></i>
                            ),
                        ]}
                        onClick={(e) => {
                            e.preventDefault();
                            props.fnMessageClear();
                            props.fnNewEditThread(
                                props.currentPage === "new" ? "POST" : "PUT"
                            );
                        }}
                        text={
                            localized[
                                props.currentPage === "new"
                                    ? "Label.Post"
                                    : "Label.Edit"
                            ]
                        }
                    />
                </StyledButtonListItem>
            </StyledButtonList>
        </StyledContainer>
    );
};
